import { __read, __spreadArray } from "tslib";
import { OfficeActionId } from '@office-start/action-types';
import { useDocumentActionsCreator } from '@office-start/actions-service';
import { useCapabilities } from '@office-start/capabilities-service';
import { ActionContextMenuItemIcon, FileType, } from '@office-start/document-types';
import { IconNames } from '@office-start/fabric-icon-subset-utility';
import { useRemoveRecommendedDocMutation, useSuggestedTasksActionsMutation, } from '@office-start/recommended-data-service';
import { PotentialActionType, } from '@office-start/recommended-types';
import { useCallback } from 'react';
var RightAlignedShareControlStyle = { right: '5%', top: '48px' };
/**
 * This hook will return a callback to generate a set of Actions for the Actions Menu for the documents in the Recommended section.
 */
export function useRecommendedDocumentActionsCreator(dataProvider, locStrings) {
    var documentActionsCreator = useDocumentActionsCreator();
    var capabilities = useCapabilities().data;
    var _a = __read(useRemoveRecommendedDocMutation(dataProvider), 1), removeFunction = _a[0];
    var _b = __read(useSuggestedTasksActionsMutation(dataProvider), 1), performMarkAsNotATask = _b[0];
    var actionsCreator = useCallback(function (item, index, targetElementId, rightAlignShare) {
        if (!documentActionsCreator || !locStrings || !capabilities) {
            return {
                actionMenuItems: [],
                commandItems: [],
            };
        }
        var removeFromListTitle = locStrings.recommendedSectionResources
            .removeFromListActionTitle;
        var removeFromList = function () {
            removeFunction({
                docId: item.id,
                docFileType: item.fileType,
                feedbackId: item.feedbackId,
            });
        };
        var markAsNotATask = function () {
            var _a, _b;
            performMarkAsNotATask({
                feedbackId: (_a = item.feedbackId) !== null && _a !== void 0 ? _a : '',
                actionType: PotentialActionType.MarkAsNotATask,
                payload: (_b = (item.potentialActions &&
                    item.potentialActions[0].actionPayload)) !== null && _b !== void 0 ? _b : '',
            });
            removeFunction({
                docId: item.id,
                docFileType: item.fileType,
                feedbackId: item.feedbackId,
            });
        };
        var notATaskTitle = locStrings.recommendedSectionResources.notATaskActionTitle;
        var additionalActions = [];
        if (item.fileType === FileType.MyAnalytics) {
            additionalActions.push({
                title: notATaskTitle,
                ariaLabel: notATaskTitle,
                id: 'notatask',
                executeAction: markAsNotATask,
                icon: IconNames.Cancel,
                contentActionOptions: {
                    icon: {
                        type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                        iconName: 'DismissIcon',
                    },
                },
            });
        }
        additionalActions.push({
            title: removeFromListTitle,
            ariaLabel: removeFromListTitle,
            id: 'remove',
            executeAction: removeFromList,
            icon: IconNames.Remove,
            contentActionOptions: {
                icon: {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'SubtractIcon',
                },
            },
        });
        var targetUX = {
            targetElementId: targetElementId,
            style: rightAlignShare
                ? RightAlignedShareControlStyle
                : undefined,
        };
        var standardDocumentActions = documentActionsCreator.createDocumentActions(item, index, targetUX, 'Recommended', 'recommended-mru') || [];
        return {
            actionMenuItems: __spreadArray(__spreadArray([], __read(standardDocumentActions.filter(function (action) { return !action.id.endsWith(OfficeActionId.Delete); })), false), __read(additionalActions), false),
            commandItems: [],
            contentActionsEnabled: capabilities.contentActionsEnabled,
            contentActionsGroupInfo: documentActionsCreator.getContentActionsGroupInfo(),
        };
    }, [
        capabilities,
        documentActionsCreator,
        locStrings,
        performMarkAsNotATask,
        removeFunction,
    ]);
    return actionsCreator;
}
//# sourceMappingURL=useRecommendedDocumentActionsCreator.js.map